import { defineComponent as _defineComponent } from 'vue'
import ButtonComponent from "./ButtonComponent.vue"
import errorIcon from "@/assets/images/modal-icon-times-circle.svg"
import successIcon from "@/assets/images/modal-icon-check-circle.svg"
import { computed } from "vue"

interface FeedbackModalProps {
  mainTitle: string
  subTitle: string
  okTitle: string
  success: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackModal',
  props: {
    mainTitle: { default: "Are you sure?" },
    subTitle: { default: "Are you sure?" },
    okTitle: { default: "OK" },
    success: { type: Boolean, default: false }
  },
  emits: ["confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const iconSrc = computed(() => {
  return props.success ? successIcon : errorIcon
})

const onConfirm = () => {
  emit("confirm")
}

const __returned__ = { props, emit, iconSrc, onConfirm, ButtonComponent, get errorIcon() { return errorIcon }, get successIcon() { return successIcon }, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})